import { apiFetch, httpError } from '../services/apiFetch';

const API_URL = import.meta.env.VITE_API_URL;

export async function fetchDashboardInsights() {
    const res = await apiFetch(`${API_URL}/api/Insights/GetDashboardInsights`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch dashboard insights');
    return res.json();
}

export async function fetchJobInsights(jobId) {
    const res = await apiFetch(`${API_URL}/api/Insights/GetJobInsights/${jobId}`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch job insights');
    return res.json();
}

export async function fetchJobTypes() {
    const res = await apiFetch(`${API_URL}/api/Insights/GetJobTypes`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch job types');
    return res.json();
}

export async function updateJobType(id, jobType) {
    const res = await apiFetch(`${API_URL}/api/Job/UpdateJobType/${id}`, {
        method: 'PUT',
        body: JSON.stringify({ jobType }),
    });
    if (!res.ok) throw await httpError(res, 'Failed to update job type');
}

export async function rateJob(id, rating, note) {
    const res = await apiFetch(`${API_URL}/api/Job/RateJob/${id}`, {
        method: 'PUT',
        body: JSON.stringify({ rating, note }),
    });
    if (!res.ok) throw await httpError(res, 'Failed to rate job');
}
